module.exports = __webpack_public_path__ + "media/LandingPageAssets/HeroIphone-080d7576.png";